import { render, staticRenderFns } from "./FlightsiteFooter.vue?vue&type=template&id=c94b9e42&scoped=true&"
import script from "./FlightsiteFooter.vue?vue&type=script&lang=js&"
export * from "./FlightsiteFooter.vue?vue&type=script&lang=js&"
import style0 from "./FlightsiteFooter.vue?vue&type=style&index=0&id=c94b9e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94b9e42",
  null
  
)

export default component.exports